module.exports = __webpack_public_path__ + "img/linkedin.1e725aca.svg";